<template lang="pug">
.d-flex
  .flex-grow-1
    filter-amount.mr-2(ref="amount" :filter.sync="amountFilter" check-initial-value)
    filter-name.mr-2(ref="name" :filter.sync="nameFilter" check-initial-value)
    filter-date.mr-2(ref="created" :filter.sync="dateFilter" title="Created date" check-initial-value)
    filter-payment-method(ref="payment" :filter.sync="paymentFilter" filterKey="payment_ref_ids" check-initial-value)
  v-btn.button-sm.underline.px-0(text @click="resetFilters" :disabled="allFilters.length === 0") Reset filters
</template>

<script>
import FilterAmount from '@/components/module/filter/FilterAmount.vue'
import FilterName from '@/components/module/filter/FilterName.vue'
import FilterDate from '@/components/module/filter/FilterDate.vue'
import FilterPaymentMethod from '@/components/module/filter/FilterPaymentMethod.vue'

export default {
  name: 'FilterRow',
  components: { FilterAmount, FilterName, FilterDate, FilterPaymentMethod },
  props: ['filters', 'propFilters'],
  data: () => ({
    amountFilter: {},
    nameFilter: {},
    dateFilter: {},
    paymentFilter: {},
  }),
  computed: {
    allFilters () {
      const filters = []
      if (this.amountFilter.key) {
        if (this.amountFilter.key === 'between') {
          const values = this.amountFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.amountFilter)
        }
      }
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.dateFilter.key) {
        if (this.dateFilter.key === 'between') {
          const values = this.dateFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.dateFilter)
        }
      }
      if (this.paymentFilter.key) {
        filters.push(this.paymentFilter)
      }
      return filters
    },
    dataFilters () {
      return {
        amountFilter: this.amountFilter,
        nameFilter: this.nameFilter,
        dateFilter: this.dateFilter,
        paymentFilter: this.paymentFilter,
      }
    }
  },
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  methods: {
    setFilters () {
      this.amountFilter = this.propFilters?.amountFilter || {}
      this.nameFilter = this.propFilters?.nameFilter || {}
      this.dateFilter = this.propFilters?.dateFilter || {}
      this.paymentFilter = this.propFilters?.paymentFilter || {}
      this.$nextTick(() => {
        this.$refs.amount.setData()
        this.$refs.name.setData()
        this.$refs.created.setData()
        this.$refs.payment.setData()
      })
    },
    resetFilters () {
      this.amountFilter = {}
      this.nameFilter = {}
      this.dateFilter = {}
      this.paymentFilter = {}
    }
  }
}
</script>